export type EntryValueValidation = {
  isValid: boolean;
  // Value to send back: trimmed, float decimal comma normalized to a dot.
  normalizedValue: string;
  // Translation key of the validation error, set when the value is invalid
  // but not empty (an empty input shows no error, just a disabled confirm).
  errorKey?: string;
};

export const validateEntryValue = (
  valueType: 'string' | 'int' | 'float',
  rawValue: string
): EntryValueValidation => {
  const trimmed = rawValue.trim();

  if (valueType === 'int') {
    const isValid = /^-?\d+$/.test(trimmed);
    return {
      isValid,
      normalizedValue: trimmed,
      errorKey:
        isValid || trimmed === '' ? undefined : 'entryError.invalidInteger',
    };
  }

  if (valueType === 'float') {
    const normalizedValue = trimmed.replace(',', '.');
    const isValid = /^-?\d+(\.\d+)?$/.test(normalizedValue);
    return {
      isValid,
      normalizedValue,
      errorKey:
        isValid || trimmed === '' ? undefined : 'errors.invalidNumber',
    };
  }

  return { isValid: trimmed !== '', normalizedValue: rawValue };
};
